import { render } from "./ModalUpdateComp.vue?vue&type=template&id=cbe62772"
import script from "./ModalUpdateComp.vue?vue&type=script&lang=js"
export * from "./ModalUpdateComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__